import { FormFieldType } from "../screens/OfficeInfo/Tabs/OfficeProfileData";
import { SelectOption } from "../components/Select/SelectNew";
import { SubscriptionType } from "../models/annual-plan.model";

export interface PlanFormDataType {
  id: string;
  value: string;
  title: string;
  required: boolean;
  valid: boolean;
  type: FormFieldType;
  options?: SelectOption[];
  planName?: string;
  testingID?: string;
}

export enum PlanTypes {
  Single = "Single",
  Couple = "Couple",
  Family = "Family",
  Senior = "Senior",
  SeniorCouple = "Senior Couple",
}

interface PlanConfig {
  type: PlanTypes;
  planName: string;
  testingID: string;
}

const PLAN_CONFIGS: PlanConfig[] = [
  { type: PlanTypes.Single, planName: "Individual Plan", testingID: "single" },
  { type: PlanTypes.Couple, planName: "Couples Plan", testingID: "couple" },
  { type: PlanTypes.Family, planName: "Family Plan", testingID: "family" },
  { type: PlanTypes.Senior, planName: "Senior Individual Plan", testingID: "senior" },
  { type: PlanTypes.SeniorCouple, planName: "Senior Couples Plan", testingID: "seniorCouple" },
];

// Create a lookup map for plan names
const PLAN_NAME_MAP = new Map(PLAN_CONFIGS.map(config => [config.type, config.planName]));

const createPlanFormData = (config: PlanConfig): PlanFormDataType[] => {
  const { type, planName, testingID } = config;
  const planNameType = PLAN_NAME_MAP.get(type) || "";

  return [
    {
      id: type,
      title: planNameType,
      value: "",
      required: false,
      valid: true,
      type: FormFieldType.SectionHeader,
      planName,
    },
    {
      id: `${testingID}PlanMonthlySubscriptionId`,
      title: SubscriptionType.Monthly,
      value: "",
      required: false,
      type: FormFieldType.SelectNew,
      options: [],
      valid: false,
      planName,
      testingID,
    },
    {
      id: `${testingID}PlanYearlySubscriptionId`,
      title: SubscriptionType.Yearly,
      value: "",
      required: false,
      type: FormFieldType.SelectNew,
      options: [],
      valid: false,
      planName,
      testingID,
    },
  ];
};

export const PLAN_FORM_DATA: PlanFormDataType[] = PLAN_CONFIGS.flatMap(createPlanFormData);
